import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';

const About = ({ onGetStarted, showGetStarted }) => {
  return (
    <div className="page-container">
      <Typography variant="h4" component="h1" sx={{ my: 2 }}>Welcome to GeoVerses</Typography>
      <Typography variant="body1" sx={{ mb: 2, textAlign: 'left' }}>
        Leave your poems at physical locations in the world for others to find, or use the map to seek out what others have written.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, textAlign: 'left' }}>
        Remember other users will need to be physically nearby to read your poems so think about the details that make this place special. Or just write a poem. Ultimately what you share with the world is up to you.
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2, textAlign: 'left' }}>
        GeoVerses is currently in alpha. Various features may or may not work at all. We'll try to save any poems you manage to write before release but no promises!
      </Typography>
      {showGetStarted && (
        <Button variant="contained" onClick={onGetStarted} sx={{ mt: 2 }}>
          Get Started
        </Button>
      )}
      <Typography variant="caption" color="text.secondary" sx={{ mt: 4, textAlign: 'left', width: '100%' }}>
        
        <br />
        Built with{' '}
        <Link href="https://mui.com/" target="_blank" rel="noopener noreferrer" color="inherit" underline="hover">
          MUI
        </Link>
        {' '}and{' '}
        <Link href="https://leafletjs.com/" target="_blank" rel="noopener noreferrer" color="inherit" underline="hover">
          Leaflet
        </Link>
        .
        <br />
        Plume icon from{' '}
        <Link href="https://commons.wikimedia.org/wiki/File:Plume.svg" target="_blank" rel="noopener noreferrer" color="inherit" underline="hover">
          Wikimedia Commons by Balthazarn
        </Link>
        , licensed under{' '}
        <Link href="https://creativecommons.org/licenses/by-sa/3.0/" target="_blank" rel="noopener noreferrer" color="inherit" underline="hover">
          CC BY-SA 3.0
        </Link>
              .<br />
              Copyright {new Date().getFullYear()} Elliott Goebel. All rights reserved.
      </Typography>
    </div>
  );
};

export default About;